import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HelperService } from '../../shared/services/helper.service';

@Injectable({
    providedIn: 'root'
})
export class FavouriteGuard implements CanActivate {
    constructor(private _helper: HelperService,
                private router: Router) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if(!this._helper.hasPermission('user:favourites')){
            this.router.navigate(['app/no-permission']);
            return false;
        }else{
            return true;
        }
    }

}
